import React, { useEffect, useState } from 'react'
import './SingleTravel.min.css'
import { AiFillDelete, AiFillEdit, AiOutlineClose } from 'react-icons/ai'
import axios from 'axios';
import { Travel } from '../TravelsPlanned/model'
import Travels from '../Travels/Travels';
import Swal from 'sweetalert2'
import { ipAddress } from '../../ipAddress';

interface Baggage {
  id: number;
  name: string;
  isDone: number;
}

interface Props {
  baggages: Baggage[];
  setBaggages: React.Dispatch<React.SetStateAction<Baggage[]>>;
  baggage: Baggage;
  travel: Travel;
}


const ShoppingTravel: React.FC<Props> = ({ baggages, setBaggages, baggage, travel }) => {
  const [edit, setEdit] = useState<boolean>(false);
  const [editBaggage, setEditBaggage] = useState<string>(baggage.name);
  const [addOption, setAddOption] = useState<boolean>(false);



  const handleChange = (id: number, isDone: number, city: string) => {
    if (isDone === 1) {
      isDone = 0
    } else {
      isDone = 1
    }
    axios.post(ipAddress + '/doneBaggageTravel', {
      id: id,

      isDone: isDone,
    })

    // setBaggages(baggages.map((baggage) => baggage.id == id ? {...baggage, isDone: 0}: baggage ))

  };





  const handleDelete = (id: number, name: string) => {
    Swal.fire({
      title: name,
      text: "Czy jesteś pewien, że chcesz usunąc ten element ?",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + '/deleteBaggageTravel', {
          id: id,
        })
        // setCosts(costs.filter((cost) => (cost.id !== id) ))
      }
    })

  }

  

  const handleEdit = (e: React.FormEvent, id: number) => {
    e.preventDefault();
    setAddOption(false)
    axios.post(ipAddress + "/editBaggage", {
      baggage: editBaggage,
      id: id,

    })
      .then((response) => {
        /*  setTravels(travels.map((travel) => (
           travel.id === id ? {...travel, city:editCity , date: editDate } : travel
         ))) */
      })
      .catch(function (error) {
        console.log("error!")

      })

    setEdit(false)
  }

  const close = () => {
    setEdit(false);
    setEditBaggage(baggage.name)
  }

  const resize = () => {
    let element = document.getElementById("textAreaEditBaggage")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }
  



  return (

    <div className='list'>

      <div className='done'>

        {baggage.isDone == 1 ? (
          <span>
            <input type='checkbox' checked={true}
              onChange={() => handleChange(baggage.id, baggage.isDone, travel.city)}
            ></input>
            <s className='text'> {baggage.name} </s>

          </span>

        ) : (
          <span>
            <input type='checkbox' checked={false}
              onChange={() => handleChange(baggage.id, baggage.isDone, travel.city)}
            ></input>
            <div className='icons'>
            <span className='edit' onClick={() => setEdit(true)} ><AiFillEdit /></span>
            <span className='delete' onClick={() => handleDelete(baggage.id, baggage.name)} ><AiFillDelete /></span>
            </div>
            <span className='text'> {baggage.name}</span>

          

          </span>
        )
        }
       
      </div>

      {edit ? (
        <form className='editBaggage' onSubmit={(e) => { handleEdit(e, baggage.id) }}>
          <button type='button'  id='close' onClick={() => close()} >X</button>
          <p>Edytuj rzecz do spakowania</p>
          <div className='thing'>
            <label htmlFor="thing">Co: </label>
            <textarea id='textAreaEditBaggage'
              rows={4}

              value={editBaggage}
              onChange={(e) => (resize(), setEditBaggage(e.target.value))}
              onClick={() => resize()}
            ></textarea>
          </div>

          <button type='submit' id='submit'>OK</button>
        </form>
      ) : (
        <span></span>
      )
      }

    </div>



  )
}

export default ShoppingTravel